<template>
  <div class="agreement-content">
    <div class="agreement-container">
      <div class="container-title">协议信息</div>
      <div class="container-body">
        <el-form
          :model="query"
          :inline="true"
          :rules="rules"
          label-width="140px"
        >
          <el-col :span="12">
            <el-form-item label="协议编号:">
              <div class="ellipsis">{{ agreementData.agreementCode }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="协议名称:">
              <div class="ellipsis">{{ agreementData.agreementName }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="协议甲方企业:">
              <div class="ellipsis">{{ agreementData.firstParty }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="供应商企业:">
              <div class="ellipsis">
                {{ agreementData.supplierCompanyName }}
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              :class="agreementData.source !== 'SL' ? 'agreement-label' : ''"
              label="采购执行企业:"
            >
              <div class="container-purchase">
                <div style="display: flex;">
                  <div class="left">
                    <div class="search">
                      <div>企业名称:</div>
                      <el-input
                        placeholder="请输入企业名称"
                        style="width: 188px"
                        v-model="companyQuery.companyName"
                      ></el-input>
                      <el-button
                        type="primary"
                        style="width: 80px;margin-left: 5px"
                        @click="companyHandleSearch"
                        >查询</el-button
                      >

                      <div>查询企业列表:</div>
                      <div class="scrollbar">
                        <el-scrollbar
                          ref="scrollbar"
                          @wheel.native.prevent="handleWheel"
                          :native="false"
                          wrap-style="overflow-x:hidden;"
                          style="height: 100%;"
                        >
                          <ul>
                            <el-checkbox-group
                              v-model="rightCompanyId"
                              @change="handleCompanyChange"
                            >
                              <li
                                class="company-li"
                                v-for="(item, index) in leftCompanyData"
                                :key="index"
                              >
                                <el-tooltip
                                  v-if="item.companyName.length > 18"
                                  :content="item.companyName"
                                  placement="top"
                                  effect="light"
                                >
                                  <el-checkbox
                                    @change="handleCompanyChange1(item)"
                                    :label="item.companyId"
                                    :key="item.companyId"
                                  >
                                    {{ item.companyName }}
                                  </el-checkbox>
                                </el-tooltip>
                                <el-checkbox
                                  @change="handleCompanyChange1(item)"
                                  :label="item.companyId"
                                  :key="item.companyId"
                                  v-else
                                >
                                  {{ item.companyName }}
                                </el-checkbox>
                              </li>
                            </el-checkbox-group>
                          </ul>
                        </el-scrollbar>
                      </div>
                    </div>
                  </div>
                  <div class="middle">
                    <img
                      style="cursor: pointer"
                      src="../../../../assets/img/agreement/right-arrow.png"
                    />
                  </div>
                  <div class="right">
                    <div>选中企业列表:</div>
                    <div class="scrollbar">
                      <el-scrollbar
                        ref="scrollbarCategory4"
                        @wheel.native.prevent="handleWheelCategory4"
                        style="height: 100%;"
                      >
                        <ul>
                          <li
                            class="scrollbar-li"
                            :class="
                              activeInx == index ? 'scrollbar-active' : ''
                            "
                            v-for="(item, index) in rightCompanyData"
                            :key="index"
                            @click="handleActive(index)"
                            @mouseover="handleActive(index)"
                          >
                            <div
                              style="display: flex;justify-content: space-between;"
                            >
                              <el-tooltip
                                :content="item.companyName"
                                placement="top"
                                effect="light"
                                :disabled="showToolTip"
                              >
                                <div
                                  @mouseleave="hideToolTips"
                                  @mousemove="showToolTips(item.companyName)"
                                  style="width: 230px;margin-right: 20px"
                                  class="ellipsis"
                                >
                                  {{ item.companyName }}
                                </div>
                              </el-tooltip>
                              <div>
                                <img
                                  @click="handleDelete(item)"
                                  style="width: 12px;height: 12px"
                                  src="../../../../assets/img/agreement/close.png"
                                />
                              </div>
                            </div>
                          </li>
                        </ul>
                      </el-scrollbar>
                    </div>
                  </div>
                </div>

                <div class="tip">
                  如无可选择采购企业，请通知其到易派客平台注册。
                </div>
              </div>
            </el-form-item>
          </el-col>
          <div v-if="agreementData.source !== 'SL'">
            <el-col :span="24">
              <el-form-item label="协议有效时间:" prop="date">
                <el-date-picker
                  v-model="query.date"
                  type="daterange"
                  value-format="yyyy-MM-dd"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item class="agreement-label" label="采购协议物料类别:">
                <div class="container-purchase">
                  <div style="display: flex;">
                    <div class="left">
                      <div class="search">
                        <div>物料类别:</div>
                        <el-input
                          placeholder="请输入最小分类名称"
                          style="width: 188px"
                          v-model="mdmCategoryQuery.mdmCategoryName"
                        ></el-input>
                        <el-button
                          type="primary"
                          style="width: 80px;margin-left: 5px"
                          @click="mdmHandleSearch"
                          >查询</el-button
                        >

                        <div>物料类别列表:</div>
                        <div class="scrollbar">
                          <el-scrollbar
                            ref="scrollbarCategory"
                            @wheel.native.prevent="handleWheelCategory"
                            :native="false"
                            style="height: 100%;"
                            v-if="searchTreeShow"
                          >
                            <el-tree
                              key="1"
                              :props="searchTreeProps"
                              :data="searchTreeData"
                              show-checkbox
                              ref="searchTree"
                              node-key="categoryId"
                              @check="getCheckedNodes"
                              @check-change="getSearchTreeCheckedNodes"
                              :default-checked-keys="defaultCheckedKeys"
                              :default-expand-all="true"
                            >
                              <template slot-scope="{ node }">
                                <el-tooltip
                                  v-if="node.label.length > 15"
                                  class="item"
                                  effect="dark"
                                  :content="node.label"
                                  placement="right"
                                >
                                  <div style="width:205px" class="ellipsis">
                                    {{ node.label }}
                                  </div>
                                </el-tooltip>
                                <span v-else> {{ node.label }}</span>
                              </template>
                            </el-tree>
                          </el-scrollbar>
                          <el-scrollbar
                            ref="scrollbarCategory2"
                            @wheel.native.prevent="handleWheelCategory2"
                            style="height: 100%;"
                            v-else
                          >
                            <el-tree
                              class="tree"
                              key="2"
                              :props="defaultProps"
                              :data="treeData"
                              show-checkbox
                              node-key="categoryId"
                              ref="tree"
                              lazy
                              :load="loadNode"
                              @check="getCheckedNodes"
                              @check-change="getTreeCheckedNodes"
                              :default-checked-keys="defaultCheckedKeys"
                            >
                              <template slot-scope="{ node }">
                                <el-tooltip
                                  v-if="node.label.length > 15"
                                  class="item"
                                  effect="dark"
                                  :content="node.label"
                                  placement="right"
                                >
                                  <div style="width:205px" class="ellipsis">
                                    {{ node.label }}
                                  </div>
                                </el-tooltip>
                                <span v-else> {{ node.label }}</span>
                              </template>
                            </el-tree>
                          </el-scrollbar>
                        </div>
                      </div>
                    </div>
                    <div class="middle">
                      <img
                        style="cursor: pointer"
                        src="../../../../assets/img/agreement/right-arrow.png"
                      />
                    </div>
                    <div class="right">
                      <div>选中物料类别列表:</div>
                      <div class="scrollbar">
                        <el-scrollbar
                          ref="scrollbarCategory3"
                          @wheel.native.prevent="handleWheelCategory3"
                          style="height: 100%;"
                        >
                          <ul>
                            <li
                              class="scrollbar-li"
                              :class="
                                activeMdmInx == index ? 'scrollbar-active' : ''
                              "
                              v-for="(item, index) in mdmDataList"
                              :key="index"
                              @click="handleMdmActive(index)"
                              @mouseover="handleMdmActive(index)"
                            >
                              <div
                                style="display: flex;justify-content: space-between;"
                              >
                                <el-tooltip
                                  v-if="item.categoryName.length > 15"
                                  :content="item.categoryName"
                                  placement="top"
                                  effect="light"
                                >
                                  <div
                                    style="width: 230px;margin-right: 20px"
                                    class="ellipsis"
                                  >
                                    {{ item.categoryName }}
                                  </div>
                                </el-tooltip>
                                <div
                                  v-else
                                  style="width: 230px;margin-right: 20px"
                                  class="ellipsis"
                                >
                                  {{ item.categoryName }}
                                </div>
                                <div>
                                  <img
                                    @click="handleDeleteData(item)"
                                    style="width: 12px;height: 12px"
                                    src="../../../../assets/img/agreement/close.png"
                                  />
                                </div>
                              </div>
                            </li>
                          </ul>
                        </el-scrollbar>
                      </div>
                    </div>
                  </div>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="备注:">
                <el-input
                  type="textarea"
                  v-model="query.remark"
                  style="width: 725px; height: 60px"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="附件:">
                <el-upload
                  class="hide-upload"
                  style="width: 350px"
                  :action="uploadAction"
                  :headers="headers"
                  :on-remove="handleRemove"
                  :file-list="hideFileList"
                  multiple
                  v-if="hideFileList.length"
                >
                </el-upload>
                <el-upload
                  :action="uploadAction"
                  :headers="headers"
                  :on-success="handleSuccess"
                  :on-error="handleError"
                  multiple
                  :limit="5"
                  :file-list="hideFileList"
                  accept=".PDF"
                  :on-exceed="masterFileMax"
                  ref="uploadFiles"
                  :show-file-list="false"
                >
                  <el-button type="primary">上传</el-button>
                  <div
                    slot="tip"
                    style="width: 705px;color: #666666; font-size: 12px"
                  >
                    您点击上传按钮，可上传协议附件，只能上传PDF格式，最多上传5个文件。
                  </div>
                </el-upload>
              </el-form-item>
            </el-col>
          </div>
        </el-form>
      </div>
    </div>

    <div style="margin-top: 10px">
      <el-button
        type="primary"
        @click="handleSLConfirm"
        v-if="agreementData.source === 'SL'"
        >确定</el-button
      >
      <el-button type="primary" @click="handleOk" v-else>确定</el-button>
      <el-button @click="handleCancel">取消</el-button>
    </div>

    <company-dialog
      v-if="companyDialogShow"
      :visible="companyDialogShow"
      :dataDetail="dataDetail"
      :dialog-key="dialogKey"
      @getCompanyInfo="getCompanyInfo"
      @close="closePartFirst"
    ></company-dialog>
  </div>
</template>

<script>
import CompanyDialog from '../../components/agreement/agreementManage/companyDialog';
import Api from '../../api/agreement/index';
import api from '../../api/product/index';
import { epecToken } from '../../utils/globalData';
import { validateStrLen } from '../../utils/validate';
export default {
  name: 'agreementAdd',
  components: {
    CompanyDialog
  },
  props: {},
  data() {
    return {
      agreementData: {},
      query: {
        agreementCode: '',
        agreementName: '',
        firstParty: '',
        supplierCompanyName: '',
        date: [],
        remark: '',
        firstPartyId: '',
        supplierCompanyId: ''
      },
      companyDialogShow: false,
      multipleSelection: true,
      dataDetail: {},
      dialogKey: 1, //1是采购商，2是供应商
      fileList: [],
      rules: {
        date: [{ required: true, trigger: 'blur', message: '日期不能为空' }]
      },
      indexShow: true,
      agreementId: 0,
      uploadAction: '',
      headers: epecToken,
      firstPartyList: [],
      mdmDataList: [],
      defaultCheckedKeys: [],
      timer: null,
      leftCompanyData: [],
      rightCompanyDataTmp: [],
      companyQuery: {
        companyName: ''
      },
      rightCompanyData: [],
      rightCompanyId: [],
      activeInx: '',
      mdmCategoryQuery: {
        mdmCategoryName: ''
      },
      activeMdmInx: '',
      treeData: [],
      defaultProps: {
        label: function(a) {
          return a.mdmCategoryCode + '-' + a.categoryName;
        },
        isLeaf: 'leaf',
        disabled: function(a) {
          return a.categoryLevel == 1;
        }
      },
      searchTreeProps: {
        label: function(a) {
          return a.mdmCategoryCode + '-' + a.categoryName;
        },
        children: 'children',
        disabled: function(a) {
          return a.categoryLevel == 1;
        }
      },
      checkingNodeList: [],
      searchTreeShow: false,
      searchTreeData: [],
      showToolTip: true,
      hideFileList: []
    };
  },
  computed: {},
  created() {
    this.getAgreementDetail();
  },
  filter: {
    ellipsis(value, len) {
      if (!value) return '';
      if (value.length > len) {
        return value.slice(0, len) + '...';
      }
      return value;
    }
  },
  methods: {
    //获取详情信息
    getAgreementDetail() {
      Api.getAgreementDetail({
        agreementId: this.$route.query.agreementId
      }).then(res => {
        if (res.data) {
          this.agreementData = res.data;
          this.query.date[1] = this.agreementData.endDate;
          this.query.date[0] = this.agreementData.startDate;
          this.query.remark = this.agreementData.remark;
          //初始化上传文件列表
          for (
            let i = 0;
            i < this.agreementData.agreementAttachment.length;
            i++
          ) {
            let obj = {};
            obj.name = this.agreementData.agreementAttachment[i].attachmentName;
            obj.url = this.agreementData.agreementAttachment[i].attachmentPath;
            this.hideFileList.push(obj);

            let obj1 = {};
            obj1.attachmentName = this.agreementData.agreementAttachment[
              i
            ].attachmentName;
            obj1.attachmentPath = this.agreementData.agreementAttachment[
              i
            ].attachmentPath;
            this.fileList.push(obj1);
          }

          this.uploadAction = Api.uploadFiles();

          this.getMdmTypeList();

          for (let i = 0; i < this.agreementData.agreementMembers.length; i++) {
            let arr = {};
            arr.companyName = this.agreementData.agreementMembers[
              i
            ].companyName;
            arr.companyId = this.agreementData.agreementMembers[i].companyId;
            arr.agreementMemberId = this.agreementData.agreementMembers[
              i
            ].agreementMemberId;
            this.rightCompanyData.push(arr);
            this.rightCompanyId.push(arr.companyId);
          }

          //获取采购执行企业左侧列表
          // this.getCompanyList();
        }
      });
    },
    handleButton(val) {
      if (val.methods === 'handleDelete') {
        this.handleDelete(val);
      }
    },
    //单独处理盐湖得确定
    handleSLConfirm() {
      let params = this.formatParams();
      Api.editAgreementForSL(params).then(res => {
        if (res.code == '200') {
          this.$message({
            type: 'success',
            message: '您的协议已编辑成功'
          });
          this.fileList.length = 0;
          this.goToUrl();
        }
      });
    },
    handleOk() {
      let params = this.formatParams();
      Api.editAgreement(params).then(res => {
        if (res.code == '200') {
          this.$message({
            type: 'success',
            message: '您的协议已编辑成功'
          });
          this.fileList.length = 0;
          // this.$router.push({path:'/agreementManage'})
          this.goToUrl();
        }
      });
    },
    handleCancel() {
      // this.$router.push({path:'/agreementManage'})
      this.goToUrl();
    },
    getFirstPartyName(val) {
      let arr = {};
      this.firstPartyList.map(res => {
        this.rightCompanyData.map((res1, index) => {
          if (res1.companyId == res.companyId) {
            this.rightCompanyData.splice(index, 1);
          }
        });
        if (res.companyId === val) {
          this.query.firstParty = res.companyName;
          arr.companyName = res.companyName;
          arr.companyId = res.companyId;
          this.rightCompanyData.push(arr);
        }
      });
    },
    handleSelectPartFirst() {
      Api.getPartACompanyList().then(res => {
        if (res.code == '200') {
          this.firstPartyList = res.data;
        }
      });
    },
    handleSelectSupplier() {
      this.companyDialogShow = true;
      this.dialogKey = 2;
    },
    closePartFirst() {
      this.companyDialogShow = false;
      this.$nextTick(function() {
        if (this.timer) {
          clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => {
          // 100毫秒延迟解决第二次打开支付框，输入框不自动获取焦点的bug
          this.$refs.getFocus.focus(); // 等价  document.getElementById("inputValId").focus();
        }, 100);
      });
    },

    handleSuccess(response, file, fileList) {
      if (response.code == '200') {
        // this.hideFileList = fileList
        this.hideFileList.push(file);
        // this.fileList.length = 0
        // for(let i=0;i<fileList.length;i++){
        // this.hideFileList.push(fileList[i])
        this.fileList.push({
          attachmentName: file.response.data.fileName,
          attachmentPath: file.response.data.url
        });
        // }
      } else {
        this.$message({
          type: 'error',
          message: response.message
        });
        this.fileList.length = 0;
        for (let i = 0; i < fileList.length - 1; i++) {
          this.fileList.push({
            attachmentName: fileList[i].response.data.fileName,
            attachmentPath: fileList[i].response.data.url
          });
        }

        this.$refs.uploadFiles.uploadFiles.splice(fileList.length - 1, 1);
      }

      // this.fileList.push({attachmentName: response.data.fileName, attachmentPath: response.data.url})
    },
    handleRemove(file, fileList) {
      this.hideFileList.length = 0;
      this.hideFileList = fileList;
      this.fileList.length = 0;
      for (let i = 0; i < fileList.length; i++) {
        this.fileList.push({
          attachmentName: fileList[i].response.data.fileName,
          attachmentPath: fileList[i].response.data.url
        });
      }
    },
    handleError(err) {
      this.$message({
        type: 'error',
        message: err
      });
    },
    masterFileMax() {
      this.$message.warning('请最多上传5个文件');
    },
    getCompanyInfo(val) {
      if (this.dialogKey == 1) {
        this.query.firstParty = val.companyName;
        this.query.firstPartyId = val.companyId;
      } else {
        this.query.supplierCompanyName = val.companyName;
        this.query.supplierCompanyId = val.companyId;
      }
    },
    // getKeysList(keys){
    //     let params = {
    //         companyIdList: keys
    //     }
    //     if(this.customerDialogShow){
    //         Api.queryCompanyInfoList(params)
    //             .then((res) => {
    //                 if(res.data){
    //                     for(let i=0;i<res.data.length;i++){
    //                         this.rightCompanyData.push(res.data[i])
    //                     }
    //                     this.rightCompanyData = this.uniqueCompany(this.rightCompanyData)
    //                 }
    //             })
    //     }
    //
    // },
    handleDelete(val) {
      let inx = this.rightCompanyData.findIndex(item => {
        return item.companyId == val.companyId;
      });
      this.rightCompanyData.splice(inx, 1);
      let inx1 = this.rightCompanyId.findIndex(item => {
        return item == val.companyId;
      });
      this.rightCompanyId.splice(inx1, 1);
    },
    formatParams() {
      let res = {};
      res.agreementAttachment = this.fileList;
      res.agreementId = this.agreementData.agreementId;
      res.agreementCode = this.agreementData.agreementCode;
      res.agreementName = this.agreementData.agreementName;
      res.firstPartyId = this.agreementData.firstPartyId;
      res.firstParty = this.agreementData.firstParty;
      res.supplierCompanyId = this.agreementData.supplierCompanyId;
      res.supplierCompanyName = this.agreementData.supplierCompanyName;
      res.endDate = this.query.date[1];
      res.startDate = this.query.date[0];
      res.agreementMembers = this.rightCompanyData;
      res.remark = this.query.remark;
      res.agreementCategory = [];
      for (let i = 0; i < this.mdmDataList.length; i++) {
        let tmp = {
          categoryId: ''
        };
        tmp.categoryId = this.mdmDataList[i].categoryId;
        res.agreementCategory.push(tmp);
      }
      return res;
    },
    handleDeleteData(val) {
      for (let i = 0; i < this.mdmDataList.length; i++) {
        if (this.mdmDataList[i].categoryId == val.categoryId) {
          this.mdmDataList.splice(i, 1);
          break;
        }
      }
      for (let i = 0; i < this.defaultCheckedKeys.length; i++) {
        if (this.defaultCheckedKeys[i] == val.categoryId) {
          this.defaultCheckedKeys.splice(i, 1);
          if (this.searchTreeShow) {
            this.$refs.searchTree.setCheckedKeys(this.defaultCheckedKeys);
          } else {
            this.$refs.tree.setCheckedKeys(this.defaultCheckedKeys);
          }

          break;
        }
      }
    },
    async getCheckedNodes(val, nodes) {
      let isSelected =
        nodes.checkedNodes.findIndex(item => {
          return item.categoryId == val.categoryId;
        }) == -1
          ? false
          : true;

      for (let i = 0; i < nodes.checkedNodes.length; i++) {
        if (nodes.checkedNodes[i].isLeaf == 1) {
          this.mdmDataList.push(nodes.checkedNodes[i]);
        }
      }
      this.mdmDataList = this.uniqueMDMCategory(this.mdmDataList);
      // //记录半选中状态的节点
      // this.halfCheckedNodes = this.$refs.tree.getHalfCheckedNodes()
      // let halfCheckStatus = false
      // //判断该节点是否在办选节点列表中
      // for(let i=0;i<this.halfCheckedNodes.length;i++){
      //     if(this.halfCheckedNodes[i].categoryId == val.categoryId){
      //         halfCheckStatus = true
      //     }
      // }

      if (val.categoryLevel == 2 && !isSelected) {
        let res = await Api.getLeafNodes({ categoryId: val.categoryId });
        if (res.data) {
          for (let i = 0; i < res.data.length; i++) {
            for (let j = 0; j < this.mdmDataList.length; j++) {
              if (this.mdmDataList[j].categoryId == res.data[i].categoryId) {
                this.mdmDataList.splice(j, 1);
                j--;
              }
            }
          }
        }
      }

      if (val.isLeaf == 0 && isSelected) {
        let res = await Api.getLeafNodes({ categoryId: val.categoryId });
        if (res.data) {
          for (let i = 0; i < res.data.length; i++) {
            this.mdmDataList.push(res.data[i]);
          }
        }
      }

      this.defaultCheckedKeys.length = 0;

      this.mdmDataList = this.uniqueMDMCategory(this.mdmDataList);

      for (let i = 0; i < this.mdmDataList.length; i++) {
        this.defaultCheckedKeys.push(this.mdmDataList[i].categoryId);
      }
    },
    //获得搜索结果树选中的节点
    getSearchTreeCheckedNodes(val, isSelected) {
      if (!isSelected) {
        if (val.isLeaf) {
          for (let i = 0; i < this.mdmDataList.length; i++) {
            if (this.mdmDataList[i].categoryId == val.categoryId) {
              this.mdmDataList.splice(i, 1);
            }
          }
        }
      }
    },
    async getTreeCheckedNodes(val, isSelected) {
      console.log(this.$refs.tree.getCheckedKeys());
      if (!isSelected && val.isLeaf) {
        for (let i = 0; i < this.mdmDataList.length; i++) {
          if (this.mdmDataList[i].categoryId == val.categoryId) {
            this.mdmDataList.splice(i, 1);
          }
        }
      }
    },
    //对象数组去重
    uniqueCompany(arr) {
      const res = new Map();
      return arr.filter(
        arr => !res.has(arr.companyId) && res.set(arr.companyId, 1)
      );
    },
    //对象数组去重
    uniqueMDMCategory(arr) {
      const res = new Map();
      return arr.filter(
        arr =>
          !res.has(arr.categoryId) &&
          res.set(arr.categoryId, 1) &&
          arr.isLeaf === 1
      );
    },
    goToUrl() {
      this.$store.state.tagsList.map((item, index) => {
        if (item.path == this.$route.path) {
          this.$store.state.tagsList.splice(index, 1);
        }
      });
      this.$router.go(-1);
    },
    getCompanyList() {
      let params = {
        companyName: this.companyQuery.companyName
      };
      Api.queryPurchasersList(params).then(res => {
        this.leftCompanyData = res.data.records;
      });
    },
    companyHandleSearch() {
      this.getCompanyList();
    },
    handleActive(inx) {
      this.activeInx = inx;
    },
    mdmHandleSearch() {
      if (!this.mdmCategoryQuery.mdmCategoryName) {
        this.searchTreeShow = false;
      } else {
        let params = { categoryName: this.mdmCategoryQuery.mdmCategoryName };
        api.selectCategoryRouteList(params).then(res => {
          this.searchTreeShow = true;
          this.searchTreeData = this.covertATree(res.data);
        });
      }
    },
    handleMdmActive(inx) {
      this.activeMdmInx = inx;
    },
    loadNode(node, resolve) {
      let tempParentId = 0;
      if (node.level != 0) {
        tempParentId = node.data.categoryId;
      }
      let params = {
        categoryId: tempParentId
      };
      Api.addMdmType(params)
        .then(res => {
          if (res.code === '200') {
            resolve(res.data);
            this.$nextTick(() => {
              this.$refs.tree.setCheckedKeys(this.defaultCheckedKeys);
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    covertATree(arr) {
      let tempObj = [];

      //将后台返回的数组拼成一个无重复数据的大数组
      arr.forEach(item => {
        for (let i = 0; i < item.routeList.length; i++) {
          if (
            tempObj.findIndex(item1 => {
              return item1.categoryId === item.routeList[i].categoryId;
            }) == -1
          ) {
            tempObj.push(item.routeList[i]);
          }
        }
      });

      //将拼好的数组转换成树

      let cloneData = JSON.parse(JSON.stringify(tempObj));
      return cloneData.filter(parent => {
        let branchArr = cloneData.filter(
          child => parent.categoryId == child.parentId
        );
        branchArr.length > 0 ? (parent['children'] = branchArr) : '';
        return parent['parentId'] == -1;
      });
    },
    showToolTips(item1) {
      if (validateStrLen(item1) > 30) {
        this.showToolTip = false;
      }
    },
    hideToolTips() {
      this.showToolTip = true;
    },
    async getMdmTypeList() {
      let params = {
        agreementId: this.agreementData.agreementId
      };

      this.defaultCheckedKeys.length = 0;
      let res = await Api.getMdmTypeList(params);
      if (res.data) {
        this.mdmDataList = res.data;
        this.defaultCheckedKeys.length = 0;
        for (let i = 0; i < this.mdmDataList.length; i++) {
          this.$set(this.mdmDataList[i], 'isLeaf', 1);
          this.defaultCheckedKeys.push(this.mdmDataList[i].categoryId);
        }
      }
    },
    handleCompanyChange(val) {
      for (let i = 0; i < val.length; i++) {
        for (let j = 0; j < this.leftCompanyData.length; j++) {
          if (this.leftCompanyData[j].companyId == val[i]) {
            this.rightCompanyData.push(this.leftCompanyData[j]);
          }
        }
      }
      this.rightCompanyData = this.uniqueCompany(this.rightCompanyData);
    },
    handleCompanyChange1(item) {
      if (this.rightCompanyData.indexOf(item) !== -1) {
        let inx = this.rightCompanyData.indexOf(item);
        this.rightCompanyData.splice(inx, 1);
      }
    },
    handleWheel(e) {
      let wrap = this.$refs.scrollbar.$refs.wrap;
      wrap.scrollTop = wrap.scrollTop - e.wheelDeltaY;
    },
    handleWheelCategory(e) {
      let wrap = this.$refs.scrollbarCategory.$refs.wrap;
      wrap.scrollTop = wrap.scrollTop - e.wheelDeltaY;
    },
    handleWheelCategory2(e) {
      let wrap = this.$refs.scrollbarCategory2.$refs.wrap;
      wrap.scrollTop = wrap.scrollTop - e.wheelDeltaY;
    },
    handleWheelCategory3(e) {
      let wrap = this.$refs.scrollbarCategory3.$refs.wrap;
      wrap.scrollTop = wrap.scrollTop - e.wheelDeltaY;
    },
    handleWheelCategory4(e) {
      let wrap = this.$refs.scrollbarCategory4.$refs.wrap;
      wrap.scrollTop = wrap.scrollTop - e.wheelDeltaY;
    }
  }
};
</script>

<style lang="scss">
.agreement-content {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.agreement-container {
  background: #fff;
  margin-bottom: 10px;
  box-shadow: 0px 0px 10px rgb(0 0 0 / 10%);
  width: 98%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 20px;
  .container-title {
    font-size: 16px;
    color: #333;
    margin-bottom: 20px;
    width: 100%;
  }

  .container-body {
    width: 100%;
    .el-input-width {
      width: 266px;
      height: 28px;
    }
    .container-purchase {
      background: #f8f8f8;
      width: 725px;
      height: 424px;
      padding: 20px;
      display: flex;
      flex-direction: column;
      .left {
        width: 308px;
        height: 360px;
        background-color: #ffffff;
        padding: 10px 10px 10px;
        .search {
          width: 100%;
          .scrollbar {
            height: 242px;
            overflow: hidden;
          }
        }
      }
      .right {
        width: 298px;
        height: 360px;
        background-color: #ffffff;
        padding: 10px 10px 10px;
        .scrollbar {
          height: 316px;
          overflow: hidden;
          .scrollbar-li {
            display: flex;
            justify-content: space-between;
            cursor: pointer;
          }
          .scrollbar-active {
            background: #f4f7ff;
          }
        }
      }
      .middle {
        width: 60px;
        height: 360px;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          height: 35px;
          width: 18px;
        }
      }
      .tip {
        font-size: 14px;
        color: #999999;
      }
    }
    .agreement-label {
      .el-form-item__label:before {
        content: '* ';
        color: red;
      }
    }
  }
}
.hide-upload .el-upload {
  display: none !important;
}
.company-li .el-checkbox__label {
  width: 250px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.scrollbar .el-scrollbar__wrap {
  overflow: hidden;
  margin-right: 0 !important;
}
.scrollbar .el-scrollbar__bar.is-vertical {
  background: #f5f5f5;
  border-radius: 2px;
  width: 3px;
  opacity: 1;
  margin-right: -2px;
}
.scrollbar .el-scrollbar__bar.is-horizontal {
  background: #f5f5f5;
  border-radius: 2px;
  height: 3px;
  margin-bottom: -2px;
  &:hover {
    opacity: 0;
  }
}
.step {
  width: 60%;
  margin-top: 20px;
  margin-bottom: 30px;
}
.delete-btn.el-button--text {
  color: #f0250f;
  font-size: 12px;
  cursor: pointer;
}
.tree .el-tree-node__content > label.el-checkbox {
  display: none;
}
.tree .el-tree-node__children label.el-checkbox {
  display: inline-block;
}
</style>
